<agpr-take-over-panel
    [id]="id"
    [header]="'VisibilityIntelligence.monitorSettingsPanel.heading'"
    [ariaLabel]="'VisibilityIntelligence.monitorSettingsPanel.heading'"
    [responsiveWidth]="true"
    [minPanelWidth]="600"
    [maxPanelWidth]="600"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="onVisibleChange($event)"
>
    <div
        class="agpr-monitorSettingsPanel"
        [formGroup]="settingsForm"
    >
        <agpr-scroll-panel>
            <div class="agpr-monitorSettingsPanel-content">
                @if (existingQuestionCount > 0) {
                    <agpr-message [severity]="severityEnum.warning" [bottomMargin]="false">
                        <p>{{ 'VisibilityIntelligence.monitorSettingsPanel.questionsWarning' | localize: { count: existingQuestionCount } }}</p>
                    </agpr-message>
                }

                <div class="agpr-monitorSettingsPanel-field">
                    <div class="agpr-monitorSettingsPanel-fieldHeader">
                        <label class="agpr-monitorSettingsPanel-fieldLabel">
                            <span>{{ 'VisibilityIntelligence.monitorSettingsPanel.answerEngines.label' | localize }}</span>
                            <span class="agpr-monitorSettingsPanel-fieldLabel-required"> * </span>
                        </label>
                    </div>
                    <ul
                        class="agpr-monitorSettingsPanel-answerEngineList"
                        formArrayName="answerEngines"
                    >
                        @for (option of answerEngineOptions; track option.type; let i = $index) {
                            <li class="agpr-monitorSettingsPanel-answerEngineList-item">
                                <agpr-checkbox
                                    [formControlName]="i"
                                    [id]="id + '_answerEngine_' + option.type"
                                    [style]="checkboxTypes.iconBadge"
                                    [imgLabel]="appBaseHref + option.logoUrl"
                                    [checkedIcon]="'fa-circle-check'"
                                    [iconBadgeTooltip]="option.label"
                                    [binary]="true"
                                ></agpr-checkbox>
                            </li>
                        }
                    </ul>

                    @if (settingsForm.controls['answerEngines'].invalid) {
                        <agpr-form-message [marginBottom]="0">
                            {{ 'VisibilityIntelligence.monitorSettingsPanel.answerEngines.requiredError' | localize }}
                        </agpr-form-message>
                    }
                </div>

                <div class="agpr-monitorSettingsPanel-field">
                    <agpr-text-input-chips
                        formControlName="analysisFocus"
                        [id]="id + '_analysisFocus'"
                        [header]="'VisibilityIntelligence.monitorSettingsPanel.analysisFocus.label'"
                        [tooltip]="'VisibilityIntelligence.monitorSettingsPanel.analysisFocus.tooltip'"
                        [placeholder]="'VisibilityIntelligence.monitorSettingsPanel.analysisFocus.placeholder'"
                        [chipPlaceholder]="'VisibilityIntelligence.monitorSettingsPanel.analysisFocus.chipPlaceholder'"
                        [splitOnPattern]="splitOnPattern"
                        [alwaysShowChips]="true"
                        [required]="true"
                    ></agpr-text-input-chips>

                    @if (settingsForm.controls['analysisFocus'].invalid) {
                        <agpr-form-message [marginBottom]="0">
                            {{ 'VisibilityIntelligence.monitorSettingsPanel.analysisFocus.requiredError' | localize }}
                        </agpr-form-message>
                    }
                </div>

                <div class="agpr-monitorSettingsPanel-field">
                    <agpr-autocomplete
                        formControlName="language"
                        [id]="id + '_language'"
                        [label]="'VisibilityIntelligence.monitorSettingsPanel.language.label'"
                        [tooltipInfo]="'VisibilityIntelligence.monitorSettingsPanel.language.tooltip'"
                        [dropdown]="true"
                        [forceSelection]="true"
                        [clearOnBlur]="false"
                        [labelField]="'label'"
                        [suggestions]="languageOptions$"
                        [placeholder]="'VisibilityIntelligence.monitorSettingsPanel.language.placeholder'"
                        (blur)="onLanguageBlur()"
                    ></agpr-autocomplete>
                </div>

                <div class="agpr-monitorSettingsPanel-field">
                    <div class="agpr-monitorSettingsPanel-fieldHeader">
                        <label class="agpr-monitorSettingsPanel-fieldLabel">
                            {{ 'VisibilityIntelligence.monitorSettingsPanel.competitorBenchmarking.label' | localize }}
                        </label>
                        <span
                            role="img"
                            class="fa-regular fa-circle-info agpr-monitorSettingsPanel-infoIcon"
                            agprTooltip="VisibilityIntelligence.monitorSettingsPanel.competitorBenchmarking.tooltip"
                            tooltipPosition="top"
                        ></span>
                    </div>
                    <agpr-checkbox
                        formControlName="isCompetitiveBenchmarking"
                        [id]="id + '_competitorBenchmarking'"
                        [binary]="true"
                        label="VisibilityIntelligence.monitorSettingsPanel.competitorBenchmarking.enable"
                    ></agpr-checkbox>
                </div>
            </div>
        </agpr-scroll-panel>
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            [id]="id + '_cancel'"
            [style]="buttonTypes.secondary"
            label="cancel"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        <agpr-button
            [id]="id + '_done'"
            [style]="buttonTypes.primary"
            label="done"
            (click)="done()"
            [disabled]="!settingsForm.valid"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
